import React, { useCallback } from 'react';
import { NumberInput } from '@vtblife/uikit';

import { IFilterAvailableProps } from '../../new_filter/Filter2';
import { LivingAreaFilter } from '../../../models/Filter';
import { MobileFilter2 } from '../../filter/MobileFilter2';

interface ILivingAreaFilterProps extends IFilterAvailableProps {
    filter: LivingAreaFilter;
    handleChange: (value: LivingAreaFilter) => void;
    withPlaceholder?: boolean;
    isMobile?: boolean;
}

export const LivingAreaFromFilterView: React.FC<ILivingAreaFilterProps> = ({
    filter,
    handleChange,
    withoutTitle,
    isMobile
}) => {
    const onChange = useCallback((value: number | null | string) => {
        const minValue = value === null || value === undefined || isNaN(value) || value === '' ?
            null :
            Number(value.toString().replace(/\s/, ''));

        handleChange(new LivingAreaFilter({ from: minValue, to: null }));
    }, [ handleChange ]);

    return (
        <MobileFilter2 desktopTitleGap={! isMobile} filterTitle={withoutTitle ? undefined : 'Площадь жилая'}>
            <NumberInput
                value={filter.value.from ?? undefined}
                postfix='м²'
                placeholder={withoutTitle ? 'Жилая от' : 'от'}
                onChange={onChange}
                max={100_000}
                name='livingAreaFrom'
                size='s'
            />
        </MobileFilter2>
    );
};
